import { DataTool } from './DataTool'

interface Props {
  planOrganizationTaskId: number
  completed: boolean
  dueDate: Date
}
export const CoachingCapacityTool = (props: Props): JSX.Element => {
  const instructionsURL = 'https://www.gvsu.edu/autismcenter/2025-2026-rcn-application-and-contract-forms-595.htm#coachingcapacitytool'

  return (
    <DataTool
      planOrganizationTaskId={props.planOrganizationTaskId}
      completed={props.completed}
      title='Coaching Capacity Tool'
      dueDate={props.dueDate}
      instructionsUrl={instructionsURL}
      color='var(--purple-500)'
      successMessage='Coaching Capacity Tool Updated'
      dataTestId='coachingCapacityTool'
    />
  )
}
